export const Routes = {
    Login: { path: "/" },
    Dashboard: { path: "/dashboard" },
    Reports: { path: "/reports" },
    ReportPreview: { path: "/reports/preview/:eventId" },
    Settings: { path: "/settings" },
    Attendance: { path: "/attendance/:eventId" }
};